import React from "react";

const Xof = ({ width, height, size = 24, fill = "currentColor", ...props }) => (
  <svg
    {...props}
    width={width || size}
    height={height || size}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#222428" />
    <mask
      id="mask0_671_5890"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="16"
      height="16"
    >
      <rect x="4" y="4" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_671_5890)">
      <path
        d="M8.66667 17.3333V16H8C7.81111 16 7.65278 15.9361 7.525 15.8083C7.39722 15.6806 7.33333 15.5222 7.33333 15.3333C7.33333 15.1444 7.39722 14.9861 7.525 14.8583C7.65278 14.7306 7.81111 14.6667 8 14.6667H8.66667V6.66667C8.66667 6.47778 8.73055 6.31944 8.85833 6.19167C8.98611 6.06389 9.14444 6 9.33333 6H15.3333C15.5222 6 15.6806 6.06389 15.8083 6.19167C15.9361 6.31944 16 6.47778 16 6.66667C16 6.85556 15.9361 7.01389 15.8083 7.14167C15.6806 7.26944 15.5222 7.33333 15.3333 7.33333H10V11.3333H14.6667C14.8556 11.3333 15.0139 11.3972 15.1417 11.525C15.2694 11.6528 15.3333 11.8111 15.3333 12C15.3333 12.1889 15.2694 12.3472 15.1417 12.475C15.0139 12.6028 14.8556 12.6667 14.6667 12.6667H10V14.6667H12C12.1889 14.6667 12.3472 14.7306 12.475 14.8583C12.6028 14.9861 12.6667 15.1444 12.6667 15.3333C12.6667 15.5222 12.6028 15.6806 12.475 15.8083C12.3472 15.9361 12.1889 16 12 16H10V17.3333C10 17.5222 9.93611 17.6806 9.80833 17.8083C9.68055 17.9361 9.52222 18 9.33333 18C9.14444 18 8.98611 17.9361 8.85833 17.8083C8.73055 17.6806 8.66667 17.5222 8.66667 17.3333Z"
        fill="white"
      />
    </g>
  </svg>
);

export default Xof;
